import gql from "graphql-tag";

export const deleteCatalogCategoryMutation = gql`
  mutation deleteCatalogCategory($id: ID!) {
    deleteCatalogCategory(id: $id) {
      id
    }
  }
`;
